module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lcKtw"))).then(() => parcelRequire('1iHdE'));